export default {
    token: localStorage.getItem("token") || "",
    userFrom: {} // 用户信息表
};